import { create } from 'zustand';

/**
 * Decision #10's grandfather-flow latch (task-15 brief's "recon option 2"): a single module-level
 * store, populated exclusively via `api/client.ts`'s `setMustRenameHandler` seam (App.tsx wires
 * the two together once at boot, mirroring `setUnauthorizedHandler`'s own wiring) — never set
 * directly from a screen. `null` means "unknown yet" (no `/me` response observed in this tab
 * since the store was last reset, e.g. straight after a fresh page load before any query has
 * resolved) — deliberately distinct from `false`, so a gate can tell "nothing to redirect on yet"
 * apart from "confirmed, this account is fine."
 */
type MustRenameState = {
  mustRename: boolean | null;
  setMustRename: (value: boolean) => void;
  /** Test-only / logout-time reset — mirrors `pushPrompt.ts`'s own `usePushStore.reset`
   *  convention for module-level stores that need a clean slate between sessions/tests. */
  reset: () => void;
};

export const useMustRenameStore = create<MustRenameState>((set) => ({
  mustRename: null,
  setMustRename: (value) => set({ mustRename: value }),
  reset: () => set({ mustRename: null }),
}));
